module.exports = __webpack_public_path__ + "delete.png?b1f27ede5607aef3fa02bdcff0828d64";


//////////////////
// WEBPACK FOOTER
// ./src/assets/delete.png
// module id = 785
// module chunks = 0